import React from 'react';

export const Features = ({ data }) => {
  if (!data) return null;

  return (
    <section id="services">
      <div className="container">
        <div className="section-title">
          <span className="section-label">What We Do</span>
          <h2>Beyond Just Coding</h2>
          <p>
            We partner with you through the entire product lifecycle — from the
            first sketch to the live launch and beyond.
          </p>
        </div>

        <div className="row">
          {data.map((service, index) => (
            <div key={index} className="col-md-4 col-sm-6">
              <div className="service-card">
                <i className={`${service.icon} service-icon`} aria-hidden="true"></i>
                <div className="service-name">{service.name}</div>
                <p className="service-text">{service.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
